<script>
import { mapActions, mapGetters } from "vuex";
import AlertError from "@/components/alert_error";
import Loader from "@/components/widgets/loader";
import { swal } from "../../../helpers/handle_error";
import exportToExcel from "../../../helpers/export_to_excel";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  components: { AlertError, Loader },
  data() {
    return {
      //Page errors.
      errors: [],
      showLoader: true,
      showAlert: false,

      activity:"",
      
      items: [],

      // datatable
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalItemsFiltered: 0,
      pageOptions: [
        10,
        25,
        50,
        100,
        { value: Number.MAX_SAFE_INTEGER, text: "عرض الكل" },
      ],
      filter: "",
      filterOn: [],
      sortBy: "created_at",
      sortDesc: true,
      fields: [
        {
          // A virtual column that doesn't exist in items
          label: "التسلسل",
          key: "index",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
        {
          label: "الاسم الرباعي",
          key: "full_name",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "full_name",
          searchable: true,
        },
        {
          label: "تاريخ التقديم",
          key: "created_at",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "created_at",
          searchable: true,
        },
        {
          label: "الاجراءات",
          key: "settings",
          class: "col-setting-services",
          sortable: true,
          visible: this.$store.getters["auth/getUser"].hasAnyPermission([
            "show_details_volunteer_activities",
            "delete_volunteer_activities",
          ]),
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("activity", ["getCoordinators"]),
    start() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    end() {
      return Math.min(this.currentPage * this.perPage, this.totalItems);
    },
  },
  methods: {
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    ...mapActions("activity", ["getAll", "delete"]),
    search() {
      if (this.currentPage == 1) this.fetchAll(true);
      else this.currentPage = 1;
    },
    fetchAll(is_search) {
      if (!is_search) {
        this.showLoader = true;
      }

      var query = new URLSearchParams({
        draw: this.currentPage,
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      });
      query.append("_datatable", "1");
      let columns = this.fields.filter((f) => !f.isVirtual);
      columns.forEach((el, index) => {
        query.append("columns[" + index + "][data]", el.name);
        query.append("columns[" + index + "][name]", el.name);
        query.append("columns[" + index + "][orderable]", el.sortable);
        query.append("columns[" + index + "][searchable]", el.searchable);
        query.append("columns[" + index + "][search][value]", "");
        query.append("columns[" + index + "][search][regex]", "false");
      });
      query.append("search[value]", this.filter);
      query.append("search[regex]", "false");

      query.append("order[0][column]", 1);
      query.append("order[0][dir]", "desc");

      this.getAll(query)
        .then((response) => {
          this.totalItemsFiltered = response.data.recordsFiltered;
          this.totalItems = response.data.recordsTotal;

          this.items = this.getCoordinators;
          this.showLoader = false;
        })
        .catch((error) => {
          this.handleError(error);
          this.showLoader = false;
        });
    },
    async deleteItem(id) {
      if (await swal.confirm()) {
        swal.loading();
        this.delete(id)
          .then((response) => {
            this.fetchAll()
            swal.success(response.data.message);
          })
          .catch((error) => {
            this.handleError(error);
            swal.close();
          });
      }
    },
    exportTable() {
      exportToExcel(this.visibleFields(), this.items, "أستمارة الانشطة التطوعية");
    },
    //saveAsPDF
    saveAsPDF() {
      const element = this.$refs.printcontent;

      html2canvas(element, { scale: 3 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "cm", "a4");
        pdf.addImage(imgData, "PNG", 0, 0, 21, 29.7);
        pdf.save("document.pdf");
      });
    },
    showPDF(id) {
      this.activity = this.getCoordinators.find((s) => s.id == id);
      alert(this.activity);
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.fetchAll();
      },
    },
    perPage: {
      handler: function () {
        this.fetchAll();
      },
    },
  },
  created() {
    this.fetchAll();
  },
};
</script>

<template>
  <div>
    <!-- start modal-pdf -->
    <b-modal id="modal-pdf" v-if="typeof activity=='object' " centered title-class="font-18" hide-footer>
      <template #modal-title>
        <b-button @click="saveAsPDF" class="btn-sm" variant="info"
          >تحميل الاستمارة بصيغة (pdf)</b-button
        >
      </template>
      <div class="scholar-ships-print" ref="printcontent">
        <div class="center">
          <div class="text-center">
            <img src="@/assets/images/logo.png" class="logo" alt="" />
            <p class="mb-0 font-size-16">المديرية العامة للعلاقات والخدمات الاجتماعية</p>
            <p class="mb-3 font-size-12">
              أستمارة الانشطة التطوعية 
            </p>
          </div>
          <h5 style="width: 151px">معلومات المنسق:</h5>
          <hr class="title-line" />
          <div class="row mb-3">
            
            <div class="col-md-12">
              <p><strong class="mx-1">الاسم :</strong> {{activity.full_name}}</p>
              <p><strong class="mx-1">معرف التلجرام :</strong> {{activity.telegram_link}}</p>
              <p><strong class="mx-1">رقم الهاتف :</strong>{{activity.phone}}</p>
            </div>
            <div class="col-md-12">
              <p><strong class="mx-1"> اذا كان هناك اكثر من منسق يرجى كتابة معلوماتهم جميعا هنا :</strong>{{activity.note}}</p>
              
            </div>
          </div>

          <h5 style="width: 200px">معلومات البرنامج او النشاط:</h5>
          <hr class="title-line" />
          <div class="row mb-3">
            <div class="col-md-12 ">
              <p><strong class="mx-1">إسم الفريق التطوعي أو المنظمة التي تنظم هذا النشاط :</strong>{{activity.team_info.name}}</p>
            </div>
            <div class="col-md-6">
              <div v-if="activity.team_info.program_type.id==17">
                <p><strong class="mx-1">نوع البرنامج او النشاط:</strong>{{activity.team_info.another_program_type}}</p> 
              </div>
              <div v-else>
                <p><strong class="mx-1">نوع البرنامج او النشاط:</strong>{{activity.team_info.program_type.title}}</p>
              </div>
              
              <p><strong class="mx-1">تاريخ اقامة البرنامج :</strong>{{activity.team_info.date_program}}</p>
            </div>
              <div class="col-md-6">
              <p><strong class="mx-1">مكان اقامة البرنامج :</strong>{{activity.team_info.location_program}}</p>
              <p><strong class="mx-1">مدة اقامة البرنامج:</strong>{{activity.team_info.duration_program}}</p>
              </div>
          
          </div>

          <!-- <h5 style="width: 197px">المهارات والاعمال التطوعية :</h5> -->
          <hr class="title-line" />
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>هل حصلت على موافقة الجهة الرسمية المعنية كموافقة الجامعة او مسؤول المنطقة ؟ </label>
                </div>
                <p>{{activity.team_info.acceptance_type.title}}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>ما هو العدد المتوقع للفئة المستهدفة ؟ </label>
                </div>
                <p>{{activity.team_info.question_2_number_target}}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>ما هي أهداف البرنامج او النشاط ؟</label>
                </div>
                <p>{{activity.team_info.question_1_program_goal}}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>ما هي الامور التي تحتاجها من الحشد ؟ </label>
                </div>
                <p>{{activity.team_info.question_3_needs}}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>من هي الشخصيات الرسمية التي ستحضر البرنامج ؟</label>
                </div>
                <p>{{activity.team_info.question_4_characters_attending}}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>من هي الشخصيات التي ستُحيي البرنامج ؟ </label>
                </div>
                <p>{{activity.team_info.question_5_characters_implement_program}}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>ما هي التحديات التي تواجهكم لانجاح البرنامج ؟</label>
                </div>
                <p>{{activity.team_info.question_6_challenges}} </p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>عدد اعضاء الفريق القائم على تنفيذ البرنامج ؟ </label>
                </div>
                <p>{{activity.team_info.question_7_number_members}}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>وصف او شرح البرنامج : </label>
                </div>
                <p>{{activity.team_info.description}}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="">
                  <label>ملاحظات :</label>
                </div>
                <p>{{activity.team_info.note}}</p>
              </div>
            </div>
            
          </div>

        </div>
      </div>
    </b-modal>
    <!-- end modal-pdf -->

    <Loader :loading="showLoader">
      <div class="row mt-3">
        <div class="col-12">
          <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

          <!-- Header Table -->
          <div class="row mt-1">
            <!-- table_length -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  عرض&nbsp;:&nbsp;
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  &nbsp;مدخلات
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center">
                  بحث&nbsp;:&nbsp;
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="بحث..."
                    @input="search"
                    class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
                <b-button class="btn-sm mx-2" variant="primary" @click="exportTable"
                  >Excel</b-button
                >
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              show-empty
              hover
              :items="items"
              :striped="true"
              :fields="visibleFields()"
              responsive="md"
              :current-page="currentPage"
              :per-page="0"
            >

              <!-- A virtual column -->
              <template #cell(index)="data">
                {{ data.index + 1 + (currentPage - 1) * perPage }}
              </template>

              <!-- A custom formatted column Sutting -->
              <template v-slot:cell(settings)="data">
                <div class="button-items">
                  <router-link
                    v-can="'show_details_volunteer_activities'"
                    :to="{ name: 'activities.details', params: { id: data.item.id } }"
                  >
                    <b-button class="btn-sm" variant="info">التفاصيل</b-button>
                  </router-link>
                  <b-button @click="showPDF(data.item.id)" class="btn-sm" v-b-modal.modal-pdf>pdf</b-button>
                  <b-button
                    v-can="'delete_volunteer_activities'"
                    class="btn-sm ml-1"
                    variant="danger"
                    title="حذف"
                    @click="deleteItem(data.item.id)"
                    ><i class="bx bx-trash"></i
                  ></b-button>
                </div>
              </template>
            </b-table>
          </div>

          <!-- Footer Table -->
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItemsFiltered"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
              <div class="dataTables_paginate paging_simple_numbers float-start">
                <p>
                  عرض من {{ start }} الى {{ end }} من مجموع {{ totalItemsFiltered }}
                  <spam v-if="totalItemsFiltered != totalItems"
                    >(تمت تصفيته من إجمالي {{ totalItems }} إدخالاً)</spam
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
